export interface BannerMessage {
    id: string;
    type: BannerMessageType;
    title: string;
    description: string;
    published: string;
    updated: string;
}

export enum BannerMessageType {
    Info = 'Info',
    Disturbance = 'Disturbance',
    TrafficInfo = 'TrafficInformation',
    Warning = 'Warning'
}
